function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { TooltipEl } from "common/components/tooltip";
import { RestrictEntitySaving } from "common/report/constants";
import { currentProjectStore } from "common/report/stores/project-details";
import { SelectEl } from "common/components/select";
import { Directions } from "common/components/drop-menu/types";
import { ButtonLayout } from "common/components/button/constants";
export function template() {
  var _currentProjectStore$, _currentProjectStore$2, _currentProjectStore$3;
  const {
    cohortDetails
  } = this.state;
  if (!((_currentProjectStore$ = currentProjectStore.value) !== null && _currentProjectStore$ !== void 0 && _currentProjectStore$.canSaveEntity(RestrictEntitySaving.Cohorts)) && !this.attr("show-upsell-in-dropdown")) {
    return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
      theme: this.attr("theme"),
      icon: "share",
      layout: this.attr("layout")
    }, on: {
      click: this.handleUpsell
    } }, this.attr("label") && /* @__PURE__ */ jsx("span", { sel: ".button-label" }, "Upgrade to Create Cohort")), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
      "max-width": "250px"
    } }, "When you upgrade your plan, cohorts can be created and saved to use across all reports in a project."));
  }
  if (this.attr("disabled")) {
    return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
      theme: this.attr("theme"),
      disabled: this.attr("disabled"),
      icon: this.attr("icon"),
      layout: this.attr("layout")
    } }, this.attr("label")), this.attr("tooltip") && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
      "max-width": "250px"
    } }, this.attr("tooltip")));
  }
  if (cohortDetails.length === 1 && (_currentProjectStore$2 = currentProjectStore.value) !== null && _currentProjectStore$2 !== void 0 && _currentProjectStore$2.canSaveEntity(RestrictEntitySaving.Cohorts)) {
    return /* @__PURE__ */ jsx(ButtonEl, { attrs: {
      theme: this.attr("theme"),
      disabled: this.attr("disabled"),
      icon: this.attr("icon"),
      layout: this.attr("layout")
    }, on: {
      click: this.handleClick
    } }, this.attr("label"));
  }
  if (this.checkRenderUpsellModal()) {
    return /* @__PURE__ */ jsx(ButtonEl, { attrs: {
      theme: this.attr("theme"),
      disabled: this.attr("disabled"),
      icon: "brand-upgrade",
      layout: this.attr("layout")
    }, on: {
      click: this.handleClick
    } }, "Save Cohort");
  }
  return /* @__PURE__ */ jsx("div", { "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(SelectEl, { attrs: _objectSpread(_objectSpread({
    icon: {
      leftIcon: this.attr("icon")
    },
    "icon-only": !!this.attr("icon") && !this.attr("label"),
    layout: this.attr("layout"),
    theme: this.attr("theme")
  }, this.attr("layout") === ButtonLayout.Vertical ? {
    "menu-width": 230
  } : {}), {}, {
    "menu-alignment": Directions.DownCenter,
    "selected-option": this.attr("label"),
    disabled: this.attr("disabled")
  }), props: {
    sections: [{
      items: this.attr("show-upsell-in-dropdown") && !((_currentProjectStore$3 = currentProjectStore.value) !== null && _currentProjectStore$3 !== void 0 && _currentProjectStore$3.canSaveEntity(RestrictEntitySaving.Cohorts)) ? [{
        value: "upsell",
        label: "Upgrade to Create Cohort",
        icon: "share"
      }] : cohortDetails.map((cohortDetail) => ({
        value: cohortDetail.type,
        label: cohortDetail.label
      }))
    }]
  }, on: {
    change: this.handleClick
  }, "data-sentry-element": "SelectEl", "data-sentry-source-file": "template.tsx" }), this.attr("tooltip") && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    "max-width": "250px"
  } }, this.attr("tooltip")));
}
